'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPublishFailed = undefined;

var _isStatus = require('./isStatus');

var _messageStatusTypes = require('../constants/messageStatusTypes');

var isPublishFailed = exports.isPublishFailed = (0, _isStatus.isStatus)(_messageStatusTypes.PUBLISH_FAILED);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/isPublishFailed.js
// module id = 1125
// module chunks = 2 3